import type { InquiryDto, OfferDto } from '@paladin-monorepo/common';

export function resolveMilestonePartyRoles(
  userAccountId: string | undefined,
  inquiry?: Pick<InquiryDto, 'accountId'> | null,
  offer?: Pick<OfferDto, 'accountId'> | null,
): { isSupplier: boolean; isCustomer: boolean } {
  return {
    isSupplier: !!offer && userAccountId === offer.accountId,
    isCustomer: !!inquiry && userAccountId === inquiry.accountId,
  };
}
